import React from 'react';

import ShopifySelectTaskContainer from '../containers/tools/shopify/ShopifySelectTaskContainer';
import ShopifyOrderDetails from '../components/tools/shopify/ShopifyOrderDetails';
import ShopifyShippingAddress from '../components/tools/shopify/ShopifyShippingAddress/ShopifyShippingAddress';
import ShopifyReturnOrder from '../components/tools/shopify/ShopifyReturnOrder/ShopifyReturnOrder';
import ShopifyReplaceOrder from '../components/tools/shopify/ShopifyReplaceOrder/ShopifyReplaceOrder';
import ShopifyCancelOrder from '../components/tools/shopify/ShopifyCancelOrder';
import ShopifyIssueRefund from '../components/tools/shopify/ShopifyIssueRefund';
import ShopifyIssueRefundAmount from '../components/tools/shopify/ShopifyIssueRefundAmount/ShopifyIssueRefundAmount';
import ShopifyResendAccountCreationEmail from '../components/tools/shopify/ShopifyResendAccountCreationEmail';

import ShipstationCreateLabelContainer from '../containers/tools/common/ShipstationCreateLabelContainer';

import AmazonOrderDetailsComponent from '../components/tools/amazon/AmazonOrderDetailsComponent';
import AmazonSelectTaskContainer from '../containers/tools/amazon/AmazonSelectTaskContainer';
import AmazonAsurionCancelRefundOrder from '../components/tools/amazon/AmazonAsurionCancelRefundOrder';

import CustomSellerOrderDetailsContainer from '../containers/tools/CustomSellerOrderDetailsContainer';
import CustomerSellerSelectTaskContainer from '../containers/tools/CustomSellerSelectTaskContainer';

import MockCancelOrRefundFlowContainer from '../containers/tools/mock/MockCancelOrRefundFlowContainer';
import MockSelectTaskContainer from '../containers/tools/MockSelectTaskContainer';

import SimplrOrderDetails from '../components/tools/simplrOrder/SimplrOrderDetails';
import SimplrCancelOrder from '../components/tools/simplrOrder/SimplrCancelOrder/SimplrCancelOrder';
import SimplrRefundOrder from '../components/tools/simplrOrder/SimplrRefundOrder/SimplrRefundOrder';
import SimplrRefundStoreCredit from '../components/tools/simplrOrder/SimplrRefundStoreCredit/SimplrRefundStoreCredit';
import SimplrUpdateShipmentAddress from '../components/tools/simplrOrder/SimplrUpdateShipmentAddress/SimplrUpdateShipmentAddress';
import SimplrSelectTaskContainer from '../containers/tools/simplrOrder/SimplrSelectTaskContainer';

import RbiSelectTaskContainer from '../containers/tools/rbi/RbiSelectTaskContainer';
import RbiOrderDetailsComponent from '../components/tools/rbi/RbiOrderDetailsComponent';

import SalesforceSelectTaskContainer from '../containers/tools/salesforce/SalesforceSelectTaskContainer';
import SalesforceOrderDetailsComponent from '../components/tools/salesforce/SalesforceOrderDetailsComponent';

export const ORDER_TASKS = {
  shopify: {
    orderDetails: {
      title: 'Order Summary',
      page: <ShopifyOrderDetails />,
    },
    shippingAddress: {
      title: 'Shipping Address',
      page: <ShopifyShippingAddress />,
    },
    issueRefund: {
      title: 'Issue Refund',
      page: <ShopifyIssueRefund />,
    },
    issueRefundAmount: {
      title: 'Issue one time given amount',
      page: <ShopifyIssueRefundAmount />,
    },
    cancelOrder: {
      title: 'Cancel Order',
      page: <ShopifyCancelOrder />,
    },
    returnOrder: {
      title: 'Return Order',
      page: <ShopifyReturnOrder />,
    },
    replaceOrder: {
      title: 'Replace order',
      page: <ShopifyReplaceOrder />,
    },
    def: {
      title: '',
      page: <ShopifySelectTaskContainer />,
    },
    createReturnLabel: {
      title: 'Create Return Label',
      page: <ShipstationCreateLabelContainer />,
    },
    resendAccountCreationEmail: {
      title: 'Resend Account Creation Email',
      page: <ShopifyResendAccountCreationEmail />,
    },
  },
  amazon: {
    orderDetails: {
      title: 'Order Summary',
      page: <AmazonOrderDetailsComponent />,
    },
    asurionCancelRefund: {
      title: 'Cancel / Refund Asurion Order',
      page: <AmazonAsurionCancelRefundOrder />,
    },
    def: {
      title: '',
      page: <AmazonSelectTaskContainer />,
    },
  },
  simplrOrder: {
    orderDetails: {
      title: 'Order Summary',
      page: <SimplrOrderDetails />,
    },
    cancelOrder: {
      title: 'Cancel Order',
      page: <SimplrCancelOrder />,
    },
    refundOrder: {
      title: 'Refund Order',
      page: <SimplrRefundOrder />,
    },
    refundStoreCredit: {
      title: 'Issue store credit',
      page: <SimplrRefundStoreCredit />,
    },
    updateShipmentAddress: {
      title: 'Update Shipment Address',
      page: <SimplrUpdateShipmentAddress />,
    },
    def: {
      title: '',
      page: <SimplrSelectTaskContainer />,
    },
  },
  customSeller: {
    orderDetails: {
      title: 'Order Summary',
      page: <CustomSellerOrderDetailsContainer />,
    },
    def: {
      title: '',
      page: <CustomerSellerSelectTaskContainer />,
    },
  },
  custom_rbi: {
    orderDetails: {
      title: 'Order Summary',
      page: <RbiOrderDetailsComponent />,
    },
    def: {
      title: '',
      page: <RbiSelectTaskContainer />,
    },
  },
  salesforce: {
    orderDetails: {
      title: 'Order Summary',
      page: <SalesforceOrderDetailsComponent />,
    },
    def: {
      title: '',
      page: <SalesforceSelectTaskContainer />,
    },
  },
  mock: {
    refundOrder: {
      title: 'Refund Order',
      page: <MockCancelOrRefundFlowContainer />,
    },
    cancelOrder: {
      title: 'Cancel Order',
      page: <MockCancelOrRefundFlowContainer />,
    },
    def: {
      title: '',
      page: <MockSelectTaskContainer />,
    },
  },
};
